import React from 'react';

interface Props {
    src: string
    fallbackSrc?: string
}

interface State {
    src: string;
    errored: boolean
}

export default class Image extends React.Component<any, any>{

  static defaultProps = {
    fallbackSrc: "https://ddnb1aopd6qzc.cloudfront.net/assets/2d_drawing/default.png"
  }

  constructor(props: Props) {
    super(props);

    this.state = {
      src: props.src,
      origSrc: props.src,
      errored: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.src !== state.origSrc) {
      return {
        src: props.src,
        origSrc: props.src,
        errored: false
      };
    }
    return null;
  }

  onError = () => {
    if (!this.state.errored) {
      this.setState({
        src: this.props.fallbackSrc,
        errored: true,
      });
    }
  }

  render() {
    const { src } = this.state;
    const {
      src: _1,
      fallbackSrc: _2,
      ...props
    } = this.props;

    return (
      <img
        crossOrigin="anonymous"
        src={src+'?ver='+new Date().getTime()}
        alt="customImage"
        onError={this.onError}
        {...props}
      />
    );
  }
}
